import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  // IconButton,
  Slide,
  Typography,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
// import TooltipProvider from "../TooltipProvider";
// import { CircleX } from "lucide-react";
import { Button } from "components/ui";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AdminModal = () => {
  const {
    isOpen,
    actions,
    content,
    title,
    maxWidth = "md",
  } = useSelector((state) => state.adminModal);
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(closeAdminModal());
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: { maxWidth },
          bgcolor: "#fff",
          backgroundImage: "none",
          boxShadow: "none",
          padding: "20px",
          borderRadius: "8px",
        },
      }}
      TransitionComponent={Transition}
      className="centerModel"
    >
      <DialogContent className="no-scrollbar" sx={{ p: "0" }}>
        <Box className="flex items-center justify-between pb-5">
          <Typography
            sx={{ fontWeight: "550", fontSize: "18px", color: "#0b0809" }}
          >
            {title}
          </Typography>
          {/* <TooltipProvider title="Close">
            <IconButton onClick={onClose} sx={{ background: "#000", borderRadius: "50%", '&:hover': { background: "#000000cf" } }} >
              <CircleX className="text-white size-5" />
            </IconButton>
          </TooltipProvider> */}
          <Button onClick={onClose} variant="outline">
            Close
          </Button>
        </Box>
        {content}
      </DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

export default AdminModal;
